import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ru from './locales/ru.json';

// Check localStorage for saved locale, default to 'ru'
const savedLocale = localStorage.getItem('user-locale') || 'ru';

const i18n = createI18n({
  legacy: false, // Use Composition API mode
  locale: savedLocale, // Use saved locale or default
  fallbackLocale: 'ru',
  messages: {
    en,
    ru
  }
});

export default i18n;
